import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface PageProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * Root of a page built with the new CMS design system (C-CMS-DS): Geist, `ds-bg`
 * page colour, `ds-ink` text, max width + padding. Cancels the Shell's main padding
 * so the page colour fills the whole content area.
 */
export function Page({ className, children, ...props }: PageProps) {
  return (
    <div
      data-ds-page=""
      className={cn(
        "-m-2 min-h-full bg-ds-bg font-ds text-sm text-ds-ink [font-variant-numeric:tabular-nums] sm:-m-4 lg:-m-6",
        className
      )}
      {...props}
    >
      <div className="mx-auto max-w-[1360px] px-4 pb-7 pt-[22px] sm:px-7">{children}</div>
    </div>
  );
}
